export const buildCertificationState = () => ({
  certificationVersions: [],
  certificationHistory: [],
  certificationHistoryCertificationId: null,
  certificationHistoryCertification: null,
  certificationHistoryRequestToken: null,
  certificationVersionRequestToken: null,
  certificationExamRequestToken: null,
  certificationExamByVersionRequestToken: null,
  launchConfigurationRequestToken: null,
  certificationVersion: null,
  certificationExam: null,
  launchConfiguration: null,
})

const state = buildCertificationState()

export default state
